import EmailNotifications from './react-emails.vue';

export default EmailNotifications;